<template>
    <auth-layout :image="1" :isProgressBarHidden="true" :hideTerms="true">
        <div class="tokens-page">
            <div class="tokens-page__card">
                <h1 class="tokens-page__heading">{{ heading }}</h1>
                <p class="tokens-page__content">{{ content }}</p>

                <auth-verify-token-form @status-change="pageStatus = $event"></auth-verify-token-form>

                <div class="tokens-page__secure">
                    <span class="tokens-page__lock" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 16 16" focusable="false">
                            <path
                                fill="currentColor"
                                d="M12.5 7H12V5.5C12 3.57 10.43 2 8.5 2S5 3.57 5 5.5V7H4.5C3.67 7 3 7.67 3 8.5v5C3 14.33 3.67 15 4.5 15h8c.83 0 1.5-.67 1.5-1.5v-5C14 7.67 13.33 7 12.5 7zM6.2 5.5c0-1.27 1.03-2.3 2.3-2.3s2.3 1.03 2.3 2.3V7H6.2V5.5zM13 13.5c0 .28-.22.5-.5.5h-8c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v5z"
                            />
                        </svg>
                    </span>
                    <span>{{ $t('pages.auth.verify_token.secure_note') }}</span>
                </div>

                <p class="tokens-page__legal">{{ $t('pages.auth.verify_token.legal') }}</p>
            </div>
        </div>
    </auth-layout>
</template>

<script>
    import AuthLayout from '@/components/layouts/AuthLayout'
    import AuthVerifyTokenForm from '@/components/forms/auth/AuthVerifyTokenForm'

    export default {
        components: {
            AuthLayout,
            AuthVerifyTokenForm,
        },

        data() {
            const hasToken = Boolean(this.$route.query.token)
            const hasNpi = Boolean(this.$route.query.npi || this.$route.query.npiNumber)

            return {
                pageStatus: hasToken && hasNpi ? 'needs_email' : hasToken ? 'verifying' : 'manual',
            }
        },

        computed: {
            heading() {
                if (this.pageStatus === 'verifying') return this.$t('pages.auth.verify_token.heading_verifying')
                if (this.pageStatus === 'needs_npi') return this.$t('pages.auth.verify_token.heading_confirm_npi')
                if (this.pageStatus === 'needs_email') return this.$t('pages.auth.verify_token.heading_email')
                if (this.pageStatus === 'token_only') return this.$t('pages.auth.verify_token.heading_token_only')
                return this.$t('pages.auth.verify_token.heading')
            },

            content() {
                if (this.pageStatus === 'verifying') return this.$t('pages.auth.verify_token.content_verifying')
                if (this.pageStatus === 'needs_npi') return this.$t('pages.auth.verify_token.content_confirm_npi')
                if (this.pageStatus === 'needs_email') return this.$t('pages.auth.verify_token.content_email')
                if (this.pageStatus === 'token_only') return this.$t('pages.auth.verify_token.content_token_only')
                return this.$t('pages.auth.verify_token.content')
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_functions.scss';
    @import 'styles/setup/_mixins.scss';

    .tokens-page {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        padding: 0;
        text-align: left;
    }

    .tokens-page__card {
        position: relative;
        width: 100%;
        max-width: rem(520px);
        padding: rem(36px) rem(32px) rem(24px);
        background: $color-white;
        border: rem(1px) solid $color--border-base-2;
        border-radius: rem(12px);
        box-shadow: 0 rem(4px) rem(24px) rgba($color-black, 0.06);
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: rem(4px);
            background: linear-gradient(90deg, $color--accent-1 0%, $color--accent-17 100%);
        }
    }

    .tokens-page__heading {
        margin: 0 0 rem(12px);
        color: $color--accent-3;
        font-size: rem(24px);
        font-weight: 700;
        line-height: $line-height--heading;
        text-align: center;
    }

    .tokens-page__content {
        margin: 0 0 rem(28px);
        color: $color--txt-base;
        font-size: rem($font-size--form);
        line-height: $line-height--copy;
        text-align: center;
    }

    .tokens-page__secure {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: rem(8px);
        margin-top: rem(24px);
        color: $color--txt-base-3;
        font-size: rem($font-size--hint);
        line-height: $line-height--hint;
    }

    .tokens-page__lock {
        display: inline-flex;
        width: rem(14px);
        height: rem(14px);
        flex-shrink: 0;
        color: #c9a227;

        svg {
            display: block;
            width: rem(14px);
            height: rem(14px);
            max-width: rem(14px);
            max-height: rem(14px);
        }
    }

    .tokens-page__legal {
        margin: rem(16px) 0 0;
        color: $color--txt-base-3;
        font-size: rem(11px);
        line-height: $line-height--copy;
        text-align: center;
    }

    @include breakpoint(smartphone-large) {
        .tokens-page__card {
            padding: rem(32px) rem(20px) rem(24px);
        }

        .tokens-page__heading {
            font-size: rem(22px);
        }
    }
</style>
